import cx from 'classnames'
import React, { useState, useEffect, useCallback } from 'react'
import { RouteLoader } from 'src/components/Loader'
import Sidebar from 'src/components/Sidebar'
import styles from 'src/components/LayoutWrapper/layoutWrapper.module.scss'

export default function Left({ children, closeSideMenu = false, ...rest }) {
    const [collapsed, setCollapsed] = useState(
        !!localStorage.getItem('collapsed')
    )
    const [collapsing, setCollapsing] = useState(false)

    const collapseMenu = useCallback(
        value => {
            if (localStorage.getItem('menu_preferences')) {
                localStorage.removeItem('menu_preferences')
            }
            if (!value) {
                localStorage.setItem('horizon_menu_expanded', '1')
            } else {
                localStorage.setItem('horizon_menu_expanded', '0')
            }
            setCollapsed(value)
            setCollapsing(true)
        },
        [setCollapsed, setCollapsing]
    )

    useEffect(() => {
        closeSideMenu && collapseMenu(closeSideMenu)
    }, [collapseMenu, closeSideMenu])

    return (
        <div
            role={'region'}
            aria-label={'left'}
            className={cx(
                {
                    layoutWrapperCollapsed: collapsed,
                    layoutWrapperCollapsing: collapsing,
                },
                styles.layoutWrapperLeft
            )}
            onTransitionEnd={e => {
                if (e.propertyName === 'width') {
                    setCollapsing(false)
                }
            }}
            {...rest}
        >
            <React.Suspense fallback={<RouteLoader />}>
                <Sidebar
                    onCollapse={value => collapseMenu(value)}
                    collapsed={collapsed}
                />
            </React.Suspense>
        </div>
    )
}
